<template>
  <div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Export Proposals</p>
      </header>
      <section class="modal-card-body">
        <!-- File Templates -->
        <div>
          <b-field label="Template">
            <b-select
              v-model="fileExportTemplate"
              size="is-medium"
              placeholder="Select an export template..."
              :loading="loadingFileExportTemplates"
              :disabled="loadingFileExportTemplates"
              expanded>
              <option v-for="template in fileExportTemplates" :key="template.id" :value="template">{{ template.name }}</option>
            </b-select>
          </b-field>
          <!-- No Templates Available -->
          <div v-if="!loadingFileExportTemplates && fileExportTemplates.length === 0">
            <p class="has-text-centered has-text-grey-light">
              Sorry, but you do not have any eligible export templates. Please file a
              <a href="#" @click.prevent="$store.dispatch('supportRequest')" class="has-text-info">support request</a>
              for further assistance.
            </p>
          </div>
        </div>
        <!-- Loading -->
        <div v-if="loadingFileExportTemplates">
          <loading message="Loading templates..." />
        </div>
      </section>
      <footer class="modal-card-foot space-between" >
        <b-button @click="$parent.close()">Close</b-button>
        <b-button
          type="is-primary"
          :disabled="!ready || processing"
          :loading="processing"
          @click="exportToFile">Export</b-button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      loadingFileExportTemplates: false,
      fileExportTemplate: null,
      fileExportTemplates: [],
      processing: false
    }
  },
  computed: {
    ...mapGetters(['app', 'context']),
    endpoint () {
      return `${this.context.route}/proposals/bulk-export/`
    },
    query () {
      const query = {
        params: {
          template_id: this.fileExportTemplate.id,
          id: this.proposals.map(proposal => proposal.id).join()
        }
      }
      return query
    },
    ready () {
      if (this.fileExportTemplate) return true
      return false
    },
    loading () {
      return Boolean(
        this.loadingFileExportTemplates
      )
    }
  },
  methods: {
    loadFileExportTemplates () {
      this.fileExportTemplates = []
      this.loadingFileExportTemplates = true
      const endpoint = this.context.route + '/templates/'
      const query = {
        params: { data_type: 'products', direction: 'export' }
      }
      this.$http.get(endpoint, query).then(response => {
        response.data.results.forEach(result => {
          if (result.code !== '' && result.retailer !== null) {
            this.fileExportTemplates.push(result)
          }
        })
        if (this.fileExportTemplates.length === 1) {
          this.fileExportTemplate = this.fileExportTemplates[0]
        }
      }).catch(() => {
        this.$buefy.toast.open({ type: 'is-danger', message: 'An error occurred retrieving templates, please try again!' })
      }).finally(() => {
        this.loadingFileExportTemplates = false
      })
    },
    exportToFile () {
      this.processing = true
      this.$http.get(this.endpoint, this.query).then(response => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Proposals export scheduled! Please allow 5-10 minutes for delivery.' })
        this.$parent.close()
      }).finally(() => {
        this.processing = false
      })
    }
  },
  mounted () {
    this.loadFileExportTemplates()
  },
  props: {
    proposals: {
      type: Array,
      required: true
    }
  }
}
</script>
